<template>
  <DashboardTemplate class="set-feedback">
    <h2 class="color-primary mg-y-less">แบบประเมินการเรียนออนไลน์</h2>
    <h4 class="mg-y-less pd-b-3">หลักสูตร {{ course.name }}</h4>

    <div v-loading="loading" class="pd-b-3">
      <el-form
        label-position="left"
        ref="form"
        :model="form"
      >
        <div v-for="(item, index) in assessmentListSort" :key="item._id" class="review-box">
          <div  v-if="typeof item.type === 'undefined' || item.type === 1"  class="flex-display flex-column js-center ai-center">
            <div class="rate-box">
                <FeedbackRate
                  :id="item._id"
                  :number="`${index + 1}. `"
                  :name="item.name"
                  :rateDefault="getRate(item._id)"
                  :disabled="assessment.length > 0 ? true : false"
                  @setRate="setRate"
                />
            </div>
          </div>
         
          <div v-else class="comment-box">
            <el-form-item :label="item.name" :prop="`${item._id}`" :rules="[ { required: item.required, message: 'กรุณากรอกข้อความ', trigger: 'blur' },]">
                <el-input
                  type="textarea"
                  :rows="6"
                  placeholder=""
                  v-model="form[item._id]"
                  :disabled="assessment.length > 0 ? true : false"
                  @input="setComment(item._id,form[item._id])"
                >
              </el-input>
            </el-form-item>
         
          </div>
        </div>
        <div v-if="user.role == 0 && assessment.length == 0" label="" class="review-button">
          <el-button @click="review" type="primary" round 
            >รีวิว</el-button
          >
        </div>
      </el-form>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import FeedbackRate from "@/components/feedback/FeedbackRate";

import { HTTP } from "@/service/axios.js";

export default {
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  components: {
    DashboardTemplate,
    FeedbackRate
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    courseList() {
      return this.$store.state.courseList;
    },
    topicLatest() {
      return this.$store.state.topicLatest;
    },
    assessmentListSort(){
      return this.assessmentList.sort((a,b)=>{
        if(typeof a.type === 'undefined'){return -1}
        if(a.type > b.type){return 1}
        if(a.type < b.type){return -1}
        return 0
      })
    }
  },
  data() {
    return {
      rate: [],
      comment:[],
      courseId: "",
      assessmentList: [],
      assessment: [],
      loading: true,
      course: "",
      subject: "",
      topicId: "",
      form:{}
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchCouseById();
    this.fetchTakes();
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);

      let filter = this.courseList.filter(
        (filter) => filter._id == this.$route.query.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let subject = filter[0].subject.filter(
          (filter) => filter._id == this.$route.query.subjectId
        );
        if (subject.length > 0) {
          this.subject = subject[0];
          this.topicId = this.topicLatest
            ? `&topicId=${this.topicLatest}`
            : this.subject.topics.length > 0
            ? `&topicId=${this.subject.topics[0]._id}`
            : null;
        }
      }
    },
    fetchTakes() {
      let obj = {
        courseId: this.courseId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/takes`, obj)
        .then((res) => {
          
          if (res.data.success) {
            this.rate = [];
            this.assessment =
              res.data.obj.assessment.length > 0 && res.data.obj.assessment[0].assessment
                ? res.data.obj.assessment[0].assessment
                : [];
          }
          this.fetchCouseById()
        })
        .finally(() => {});
    },
    getRate(id) {

      let filter = this.assessment.filter(
        (filter) => filter.assessmentId == id
      );
      if (filter.length > 0) {
        return filter[0].point;
      } else {
        return 0;
      }
    },
    getComment(id) {

      let filter = this.assessment.filter(
        (filter) => filter.assessmentId == id
      );

      if (filter.length > 0) {
        return filter[0].comment.toString();
      } else {
        return '';
      }
    },
    fetchCouseById() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.get(`course/${this.courseId}`)
        .then((res) => {
          if (res.data.success) {
            this.assessmentList = res.data.obj.assessment;
            res.data.obj.assessment.map((item)=>{
              if (typeof item.type === 'undefined' || item.type === 1) {
                this.setRate(item._id,0)
              }else{
                if (this.getComment(item._id)) {
                  this.form[item._id] = this.getComment(item._id)
                } 
                this.setComment(item._id,'')
              }
            })
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCouseById error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    setParams() {
      if (this.routeParams != null) {
        this.courseId = this.routeParams.courseId;
      }
    },
     review() {
      let assementRate = this.assessmentList.filter((filter)=>typeof filter.type == 'undefined' || filter.type == 1)
      if (this.rate.length >= assementRate.length) {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.loading = true;

            let assessment = []
            for (let index = 0; index < this.rate.length; index++) {
              let obj ={
                assessmentId: this.rate[index].id,
                point: this.rate[index].rate,
                comment:''
              }

              assessment.push(obj)
            }

            for (let index = 0; index < this.comment.length; index++) {
               let obj ={
                assessmentId: this.comment[index].id,
                point:null ,
                comment:this.comment[index].comment
              }

              assessment.push(obj)
            }
            
            let obj = {
              type: "assessment",
              actionTo: this.courseId,
              assessment:assessment,
              courseId: this.courseId,
              subjectId: "",
              suggestion: "",
              latestTime: 0,
            };
          
            HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
            HTTP.post(`take`, obj).then((res) => {
              if (res.data.success) {
                this.$message({
                  message: "ทำแบบประเมินเรียบร้อยแล้ว",
                  type: "success",
                });
                setTimeout(() => {
                  this.$router.push(
                    `/course/learn?courseId=${this.courseId}&subjectId=${this.subject._id}${this.topicId}`
                  );
                }, 500);

              }else{
                this.alertFailError();
              }
            })
            .catch((e)=>{
              this.alertCatchError(e);
              console.log("review error", e);
            }).finally(()=>{
              setTimeout(() => {
                this.loading = false;
              }, 500);
            })
          }
        })
      } else {
        this.$message.error("กรุณาให้คะแนนรีวิว");
      }
    },
    setRate(id, rate) {
      if (rate > 0) {
        let filter = this.rate.filter((filter) => filter.id == id);

        if (filter.length == 0) {
          this.rate.push({ id: id, rate: rate });
        } else {
          let index = this.rate.findIndex((index) => index.id == id);

          if (index > -1) {
            this.rate.splice(index, 1, {
              id: id,
              rate: rate,
            });
          }
        }
      }

    },
    setComment(id, comment) {
      let filter = this.comment.filter((filter) => filter.id == id);

      if (filter.length == 0) {
        this.comment.push({ id: id, comment: comment });
      } else {
        let index = this.comment.findIndex((index) => index.id == id);

        if (index > -1) {
          this.comment.splice(index, 1, {
            id: id,
            comment: comment,
          });
        }
      }

    },
  },
};
</script>
